import { Tooltip } from '@mui/material'
import IconButton from '@/shared/components/IconButton/IconButton'
import { useRef, useState } from 'react'
import Fade from '@mui/material/Fade'
import { useClickOutsideWithExceptions } from '@/shared/hooks/useClickOutsideWithExceptions'
import { tooltipStyles } from './TooltipButton.styles'
import Button from '../Button/Button'

interface TooltipButtonProps {
  children: React.ReactNode
  icon: string
  label?: string
  placement?: 'bottom-start' | 'bottom-end'
}

function TooltipButton(props: TooltipButtonProps) {
  const { children, icon, label, placement = 'bottom-start' } = props
  const [openTooltip, setOpenTooltip] = useState(false)
  const toggleTooltip = () => setOpenTooltip(!openTooltip)

  const popperRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLDivElement>(null)

  useClickOutsideWithExceptions({
    refs: [buttonRef, popperRef],
    exceptionSelectors: [
      '.colorPickerContainer',
      '.imageCropperWrapper',
      '.MuiBox-root:has(.imageCropperWrapper)',
      '.MuiBox-root:has(.dropzoneContainer)',
      '.MuiAutocomplete-popper'
    ],
    onClickOutside: () => setOpenTooltip(false),
    disabled: !openTooltip
  })

  return (
    <Tooltip
      title={children}
      open={openTooltip}
      slots={{
        transition: Fade
      }}
      placement={placement}
      slotProps={{
        tooltip: {
          sx: { ...tooltipStyles }
        },
        popper: {
          ref: popperRef,
          sx: { zIndex: 5 },
          keepMounted: true
        },
        transition: {
          mountOnEnter: true,
          unmountOnExit: false
        }
      }}
      disableHoverListener
      disableFocusListener
      disableTouchListener
    >
      <div ref={buttonRef}>
        {icon && label ? (
          <Button
            label={label}
            icon={icon}
            variant="text"
            color="primary"
            onClick={toggleTooltip}
          />
        ) : (
          <IconButton icon={icon} color="primary" onClick={toggleTooltip} />
        )}
      </div>
    </Tooltip>
  )
}

export default TooltipButton
